import { FaUserGraduate } from 'react-icons/fa'
import { AiFillProject } from 'react-icons/ai'


export const contentData = [
    {
        id: 1,
        cardName: 'Graduate',
        cardText: 'ITC',
        icons: <FaUserGraduate className='about_icon' />
    },
    {
        id: 2,
        cardName: 'Projects',
        cardText: '+ 10',
        icons: <AiFillProject className='about_icon' />
    },
    // {
    //     id: 3,
    //     cardName: 'Experiance',
    //     cardText: '3+ Years Working',
    //     icons: <BiHome className='about_icon' />
    // }


];